import React, { useState } from 'react';
import { PanelShell } from '../ui/PanelShell';
import { SectionTitle } from '../ui/SectionTitle';
import { FieldRow } from '../ui/FieldRow';
import { NumberField } from '../ui/NumberField';
import { PillButton } from '../ui/PillButton';
import { ColorCheckbox } from '../ui/ColorCheckbox';
type LayoutPanelProps = {
  onClose: () => void;
};
export function LayoutPanel({
  onClose
}: LayoutPanelProps) {
  const [opts, setOpts] = useState({
    overlap: false,
    lock: false,
    platform2: false
  });
  const toggle = (k: keyof typeof opts) => (v: boolean) => setOpts(p => ({
    ...p,
    [k]: v
  }));
  return <PanelShell title="Layout" onClose={onClose} footer={<>
          <PillButton variant="primary" data-id="element-393" data-mp="1b45pgo1jcg84">Layout All</PillButton>
          <PillButton disabled data-id="element-394" data-mp="1b1jh4m6tlwou">Fill Build Platform</PillButton>
        </>} data-id="element-392" data-mp="1g1fbdtppu9r7">
      
      <SectionTitle data-id="element-395" data-mp="28kune6nd6yc8">Duplicate</SectionTitle>
      <FieldRow label="Duplicate Count" className="min-h-[26px]" data-id="element-396" data-mp="23rjhq8uagnlw">
        <NumberField ariaLabel="Duplicate count" value={1} decimals={0} step={1} disabled className="w-[78px]" data-id="element-397" data-mp="23q8afz1mwxq1" />
      </FieldRow>
      <PillButton disabled className="mt-[5px] w-full" data-id="element-398" data-mp="1w2p95zyyxnx5">
        Create
      </PillButton>

      <SectionTitle data-id="element-399" data-mp="1hdku2rngzzt9">Array</SectionTitle>
      <PillButton disabled className="w-full" data-id="element-400" data-mp="1hchxq47dp55y">
        Array Models...
      </PillButton>

      <SectionTitle data-id="element-401" data-mp="1mb330i1hmf19">Mirror</SectionTitle>
      <PillButton disabled className="w-full" data-id="element-402" data-mp="1ma1dx9nmzs0j">
        Mirror Models
      </PillButton>

      <SectionTitle data-id="element-403" data-mp="18epkd5l7w7l7">Layout Settings</SectionTitle>
      <FieldRow label="Model Spacing" info className="min-h-[31px]" data-id="element-404" data-mp="1ceghdr1c7jy6">
        <NumberField ariaLabel="Model spacing" value={2} decimals={1} unit="mm" className="w-[78px]" data-id="element-405" data-mp="yef7xn70b473" />
      </FieldRow>
      <FieldRow label="Platform Margin" className="min-h-[31px]" data-id="element-406" data-mp="13d08jnq67pw2">
        <NumberField ariaLabel="Platform margin" value={5} decimals={1} unit="mm" className="w-[78px]" data-id="element-407" data-mp="13fcyoo6316k7" />
      </FieldRow>
      <FieldRow label="Overlap Rafts" info className="min-h-[31px]" data-id="element-408" data-mp="2xravfqn7g9z7">
        <ColorCheckbox label="Overlap rafts" checked={opts.overlap} onChange={toggle('overlap')} data-id="element-409" data-mp="2xpgk941qjw8b" />
      </FieldRow>
      <FieldRow label="Lock Rotation" className="min-h-[31px]" data-id="element-410" data-mp="2rbapemfbxilc">
        <ColorCheckbox label="Lock rotation" checked={opts.lock} onChange={toggle('lock')} data-id="element-411" data-mp="2r9pyd6s84hs8" />
      </FieldRow>
      <FieldRow label="Optimize for Build Platform 2" info className="min-h-[31px]" data-id="element-412" data-mp="2mcg6lkhd3u18">
        <ColorCheckbox label="Optimize for build platform 2" checked={opts.platform2} onChange={toggle('platform2')} data-id="element-413" data-mp="2heo8g8q4jbol" />
      </FieldRow>
    </PanelShell>;
}